/**
 * Better Auth Client
 *
 * Provides authentication hooks and methods for the web app.
 * Uses the React client for session management and auth operations.
 */

import { createAuthClient } from "better-auth/react";

const baseUrl = import.meta.env.VITE_API_URL || "";

export const authClient = createAuthClient({
  baseURL: baseUrl,
});

// Export commonly used methods and hooks
export const { signIn, signUp, signOut, useSession } = authClient;

// Password reset helpers using Better Auth API endpoints
// Use relative paths to go through Vite proxy in development
export async function requestPasswordReset(email: string, redirectTo: string) {
  const response = await fetch("/api/auth/request-password-reset", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email, redirectTo }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || "Failed to send reset email");
  }

  return response.json();
}

export async function resetPassword(newPassword: string, token: string) {
  const response = await fetch("/api/auth/reset-password", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ newPassword, token }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || "Failed to reset password");
  }

  return response.json();
}
